import { Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/styles';
import { Grid } from '@mui/system';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
}));

const GridContainer = styled(Grid)({
  height: '100%',
});

const QuoteContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const Quote = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: 'url(/images/login-bg.jpg)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
}));

const QuoteInner = styled('div')({
  textAlign: 'center',
  flexBasis: '600px',
});

const QuoteText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 300,
}));

const NameText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
  color: theme.palette.common.white,
}));

const ContentGrid = styled(Grid)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

const ContentBody = styled('div')(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const Form = styled('form')(({ theme }) => ({
  paddingLeft: 100,
  paddingRight: 100,
  paddingBottom: 125,
  flexBasis: 700,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

const TextFieldStyled = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const SignInButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2, 0),
}));

export {
  ContentBody, ContentGrid, Form, GridContainer, NameText, Quote, QuoteContainer, QuoteInner,
  QuoteText, Root, SignInButton, TextFieldStyled, Title
};

